"use client";
import { jsxs as a, jsx as e, Fragment as m } from "react/jsx-runtime";
import { COMPONENT_SIZES as w } from "../../common/constants/componentSizes.js";
import x from "../divider/Divider.js";
import b from "../drawer/Drawer.js";
import h from "./HeaderNav.js";
import k from "../heading/Heading.js";
import N from "../icon-button/IconButton.js";
import C from "../logo/Logo.js";
import D from "../visually-hidden/VisuallyHidden.js";
import { css as u } from "@emotion/react";
import t from "@emotion/styled";
import { useMediaQuery as I } from "../../hooks/useMediaQuery.js";
import { useMounted as M } from "../../hooks/useMounted.js";
import { COLORS as l } from "../../tokens/colors/Colors.js";
import { FONT_WEIGHTS as O } from "../../tokens/font-weights/FontWeights.js";
import { MEDIA_QUERIES as g } from "../../tokens/media-queries/MediaQueries.js";
import { SPACINGS as s } from "../../tokens/spacings/Spacings.js";
import { forwardRef as E, useState as F, Fragment as L } from "react";
const H = E(
  ({ feControls: r, feIntro: n, feNavigation: o, ...c }, f) => {
    const [y, p] = F(!1), { menuButton: i } = r ?? {}, d = I("desktop"), $ = M();
    return /* @__PURE__ */ a(R, { ...c, "data-comp": "header", ref: f, stDesktop: d, children: [
      /* @__PURE__ */ e(v, { ...n }),
      o && $ && /* @__PURE__ */ a(m, { children: [
        d && /* @__PURE__ */ a(m, { children: [
          /* @__PURE__ */ e(x, { as: "div", feColor: "secondary", feInset: "md", feVertical: !0 }),
          /* @__PURE__ */ e(P, { ...o })
        ] }),
        !d && /* @__PURE__ */ a(m, { children: [
          /* @__PURE__ */ e(
            N,
            {
              ...i,
              "aria-label": (i == null ? void 0 : i["aria-label"]) ?? "Open Menu",
              as: "button",
              feColor: "white",
              feIcon: "burger",
              feSize: "lg",
              onClick: () => p(!0)
            }
          ),
          /* @__PURE__ */ e(
            V,
            {
              feNoPadding: !0,
              feOnClose: () => p(!1),
              feTitle: n.name,
              open: y,
              children: /* @__PURE__ */ e(h, { ...o, feVertical: !0 })
            }
          )
        ] })
      ] })
    ] });
  }
);
H.displayName = "Header";
const ne = H, v = ({ baseUrl: r, displayName: n = !0, name: o }) => /* @__PURE__ */ e(T, { as: "h1", feStyledAs: "h3", children: /* @__PURE__ */ a(r ? j : L, { href: r && r, children: [
  /* @__PURE__ */ e(C, { feColor: "secondary", feHeight: "auto", feWidth: "100px", title: "SKF" }),
  /* @__PURE__ */ e(n ? A : D, { children: o })
] }) }), R = t.header(
  ({ stDesktop: r }) => u`
		align-items: center;
		background-color: ${l.brand};
		display: flex;
		gap: ${s.lg};
		height: ${w.headerHeight};
		justify-content: ${!r && "space-between"};
		overflow: hidden;
		padding-inline: ${s.md};
	`
), S = u`
	display: flex;
	gap: ${s.md};

	@media screen and (${g.tabletMax}) {
		flex: auto;
	}
`, T = t(k)`
	${S};

	color: ${l.white};
	font-weight: ${O.normal};
	white-space: nowrap;
`, j = t.a`
	${S};

	color: inherit;
	text-decoration: none;
`, A = t.span`
	@media screen and (${g.tabletMax}) {
		margin-inline: auto;
	}
`, P = t(h)`
	margin-left: auto;
	min-width: 0;
`, V = t(b)`
	& > div {
		background: ${l.brand};
	}
`;
export {
  ne as default
};
